<script setup>
import { ContentBanner } from '@dashhudson/dashing-ui/content-banner';
import { useRouter } from 'vue-router';

const router = useRouter();

const ctaButton = {
  label: 'Go to Overview',
};

function goToOverview() {
  router.push({ name: 'auth.login' });
}
</script>

<template>
  <ContentBanner
    variant="pageError"
    title="Content Not Found"
    message="This link may be broken or the content may have moved"
    :cta-button="ctaButton"
    @cta-click="goToOverview"
  />
</template>
